import React from 'react';
import { motion } from 'framer-motion';

const filmfreewayUrl = process.env.REACT_APP_FILMFREEWAY_URL || 'https://filmfreeway.com/SynemaFilmFestival';

const Submit = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="font-mono text-[0.7rem] tracking-[0.25em] uppercase text-teal mb-4">
            Submit Your Film
          </div>
          <h1 className="font-display text-[clamp(2.5rem,5vw,4rem)] tracking-[0.04em] leading-none text-white mb-6">
            Show the world what you made.
          </h1>
          <p className="text-[1rem] font-light leading-[1.8] text-white/[0.65] max-w-[640px] mb-12">
            Synema accepts scenes, shorts, vertical films, features, and documentaries from filmmakers worldwide.
            All genres, all languages (English subtitles required for non-English dialogue), all experience levels.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">SUBMISSION INFO</h2>
            <div className="space-y-4">
              <div className="bg-dark2 border border-white/[0.06] rounded p-6">
                <h3 className="font-display text-xl text-teal mb-2">FEE SCHEDULE</h3>
                <div className="space-y-3">
                  {[
                    { category: 'Scene', early: '$15', regular: '$20', late: '$25' },
                    { category: 'Short / Vertical', early: '$20', regular: '$25', late: '$30' },
                    { category: 'Feature / Doc', early: '$25', regular: '$30', late: '$35' },
                  ].map((fee) => (
                    <div key={fee.category} className="border-b border-white/[0.04] pb-3 last:border-0 last:pb-0">
                      <div className="text-[0.9rem] font-medium text-white mb-1">{fee.category}</div>
                      <div className="flex gap-4 text-[0.78rem] text-white/50">
                        <span>Early Bird: <span className="font-mono text-white">{fee.early}</span></span>
                        <span>Regular: <span className="font-mono text-white">{fee.regular}</span></span>
                        <span>Late: <span className="font-mono text-white">{fee.late}</span></span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-dark2 border border-white/[0.06] rounded p-6">
                <h3 className="font-display text-xl text-teal mb-2">RULES SUMMARY</h3>
                <ul className="space-y-2 text-[0.88rem] font-light text-white/60">
                  <li className="flex gap-3 items-start">
                    <span className="w-1.5 h-1.5 rounded-full bg-teal flex-shrink-0 mt-2" />
                    All genres and formats accepted
                  </li>
                  <li className="flex gap-3 items-start">
                    <span className="w-1.5 h-1.5 rounded-full bg-teal flex-shrink-0 mt-2" />
                    English subtitles required for non-English dialogue
                  </li>
                  <li className="flex gap-3 items-start">
                    <span className="w-1.5 h-1.5 rounded-full bg-teal flex-shrink-0 mt-2" />
                    Premiere status preferred but not required
                  </li>
                  <li className="flex gap-3 items-start">
                    <span className="w-1.5 h-1.5 rounded-full bg-teal flex-shrink-0 mt-2" />
                    Synema does not acquire rights to your film
                  </li>
                </ul>
              </div>

              <div className="bg-dark2 border border-white/[0.06] rounded p-6">
                <h3 className="font-display text-xl text-teal mb-2">FEE WAIVERS</h3>
                <p className="text-[0.88rem] font-light text-white/60 leading-relaxed">
                  Fee waivers are available for filmmakers from lower-income countries and first-time filmmakers.
                  Email <a href="mailto:synemafest@gmail.com" className="text-teal font-medium">synemafest@gmail.com</a> before submitting.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col items-center justify-center"
          >
            <div className="bg-dark2 border border-teal/20 rounded p-10 text-center w-full">
              <h2 className="font-display text-3xl text-white mb-4">SUBMIT VIA FILMFREEWAY</h2>
              <p className="text-[0.9rem] font-light text-white/50 mb-8 leading-relaxed">
                All submissions are handled through FilmFreeway. Click below to visit our festival page, view the full rules, and submit your film.
              </p>
              <a
                href={filmfreewayUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-full btn-gradient text-dark font-body text-[0.82rem] font-semibold tracking-[0.08em] uppercase py-4 px-8 rounded-sm hover:opacity-90 transition-all hover:-translate-y-[1px] text-center"
              >
                Submit on FilmFreeway
              </a>
              <p className="mt-4 text-[0.75rem] text-muted">
                Questions? Email <a href="mailto:synemafest@gmail.com" className="text-teal">synemafest@gmail.com</a>
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Submit;
